import React from "react";
import { ControlLabel, FormGroup } from "react-bootstrap";

const SurveyField = ({ label, required, error, children }) => (
  <FormGroup validationState={error ? "error" : null}>
    <ControlLabel>
      {label}
      {required && <span className="survey-engine-required">*</span>}
    </ControlLabel>
    {children}
    {error && <p className="survey-engine-field-error">{error}</p>}
  </FormGroup>
);

export default SurveyField;
